import { render } from "./AdminShiftList.vue?vue&type=template&id=63f03dfe&scoped=true&ts=true&lang=true"
import script from "./AdminShiftList.vue?vue&type=script&lang=ts"
export * from "./AdminShiftList.vue?vue&type=script&lang=ts"

import "./AdminShiftList.vue?vue&type=style&index=0&id=63f03dfe&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f03dfe"]])

export default __exports__